import React from "react";
import MarketingLayout from "components/layout/MarketingLayout";
import Hero from "./Hero";
import Stats from "./Stats";
import Analytics from "./Analytics";
import Partners from "./Partners";
import Features from "./Features";
import HowItWorks from "./HowItWorks";
import Teams from "./Teams";
import Logos from "./Logos";
import Cta from "./Cta";
import Testimonials from "./Testimonials";


const HomePage: React.FC = () => {
  return (
    <MarketingLayout>
      <Hero />
      <Partners />
      <Features />
      <Stats />
      <HowItWorks />
      {/* <Analytics/> */}
      {/* <Teams /> */}
      {/* <Logos /> */}
      {/* <Testimonials /> */}
      {/* <Cta /> */}
    </MarketingLayout>
  );
};

export default HomePage;


